import React, { useEffect, useRef } from "react";
import "./Introduction.css";

const Introduction = () => {
  const titleRef = useRef(null);

  useEffect(() => {
    const title = titleRef.current;
    if (title) {
      title.style.width = "0";
      setTimeout(() => {
        title.style.width = "100%";
      }, 300);
    }
  }, []);

  return (
    <section className="intro-contenedor" id="home">
      {/* Terminal window bar */}
      <div className="terminal-window">
        <div className="terminal-bar">
          <span className="terminal-dot dot-red"></span>
          <span className="terminal-dot dot-yellow"></span>
          <span className="terminal-dot dot-green"></span>
          <span className="terminal-title">javif@portfolio:~</span>
        </div>

        <div className="terminal-body">
          {/* Line 1 - whoami */}
          <div className="terminal-line">
            <span className="prompt-user">javif</span>
            <span className="prompt-at">@</span>
            <span className="prompt-host">portfolio</span>
            <span className="prompt-sep">:</span>
            <span className="prompt-path">~</span>
            <span className="prompt-symbol">❯</span>
            <span className="terminal-cmd"> whoami</span>
          </div>

          {/* Output - Title */}
          <div className="intro-title-wrap">
            <h1 className="intro-title" ref={titleRef}>
              Javi Fiallos
            </h1>
            <span className="title-cursor">█</span>
          </div>

          {/* Line 2 - cat about.txt */}
          <div className="terminal-line mt-line">
            <span className="prompt-user">javif</span>
            <span className="prompt-at">@</span>
            <span className="prompt-host">portfolio</span>
            <span className="prompt-sep">:</span>
            <span className="prompt-path">~</span>
            <span className="prompt-symbol">❯</span>
            <span className="terminal-cmd"> cat about.txt</span>
          </div>

          {/* Output - Description */}
          <div className="intro-desc">
            <p className="desc-line">
              <span className="line-num">01</span>
              Apasionado del desarrollo web y el mundo digital.
            </p>
            <p className="desc-line">
              <span className="line-num">02</span>
              Dominio sólido de Java y enfoque en backend, con amor por el frontend.
            </p>
            <p className="desc-line">
              <span className="line-num">03</span>
              Experiencia en bases de datos, integración en la nube y DevOps.
            </p>
            <p className="desc-line">
              <span className="line-num">04</span>
              Siempre aprendiendo, construyendo experiencias únicas en línea.
            </p>
          </div>

          {/* Line 3 - ls tech */}
          <div className="terminal-line mt-line">
            <span className="prompt-user">javif</span>
            <span className="prompt-at">@</span>
            <span className="prompt-host">portfolio</span>
            <span className="prompt-sep">:</span>
            <span className="prompt-path">~</span>
            <span className="prompt-symbol">❯</span>
            <span className="terminal-cmd"> ls ./tech-stack/</span>
          </div>

          {/* Tech icons */}
          <div className="intro-tech-stack">
            <div className="tech-icon-terminal">
              <img src="./assets/images/javaIcon.svg" alt="Java" />
              <span>Java</span>
            </div>
            <div className="tech-icon-terminal">
              <img src="./assets/images/Nest.js.svg" alt="NestJS" />
              <span>NestJS</span>
            </div>
            <div className="tech-icon-terminal">
              <img src="./assets/images/Angular.svg" alt="Angular" />
              <span>Angular</span>
            </div>
            <div className="tech-icon-terminal">
              <img src="./assets/images/PostgresSQL.svg" alt="PostgreSQL" />
              <span>PostgreSQL</span>
            </div>
          </div>

          {/* Blinking cursor line */}
          <div className="terminal-line mt-line">
            <span className="prompt-user">javif</span>
            <span className="prompt-at">@</span>
            <span className="prompt-host">portfolio</span>
            <span className="prompt-sep">:</span>
            <span className="prompt-path">~</span>
            <span className="prompt-symbol">❯</span>
            <span className="input-cursor">█</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Introduction;
